// extracted by mini-css-extract-plugin
module.exports = {"componentsMarkdown":"styles_componentsMarkdown__2gHnD"};